import React from 'react';
import { Button, CircularProgress, Box, Typography } from '@mui/material';
import { Description } from '@mui/icons-material'; // Changed from AddPhotoAlternate to Description

const ImageUploader = ({ 
  onFileSelect, 
  accept = '*/*', // Changed default to accept all files
  multiple = false,
  label = 'Select File',
  uploadProgress = 0,
  showProgress = false,
  maxSize = 10 * 1024 * 1024, // Increased default to 10MB
  allowedExtensions = [] // New prop for specific extensions
}) => {
  const handleFileChange = (e) => {
    const files = Array.from(e.target.files);
    
    if (!files || files.length === 0) {
      onFileSelect(null, 'No file selected');
      return;
    }

    if (!multiple) {
      const file = files[0];
      const validationError = validateFile(file);
      if (validationError) {
        onFileSelect(null, validationError);
      } else {
        onFileSelect(file);
      }
      return;
    }

    const validFiles = [];
    const errors = [];
    
    files.forEach(file => {
      const validationError = validateFile(file);
      if (validationError) {
        errors.push(`${file.name}: ${validationError}`);
      } else {
        validFiles.push(file);
      }
    });

    if (validFiles.length > 0) {
      onFileSelect(multiple ? validFiles : validFiles[0], errors.length > 0 ? errors.join('\n') : null);
    } else {
      onFileSelect(null, errors.join('\n'));
    }
  };

  const validateFile = (file) => {
    if (!file) return 'No file selected';
    
    if (!file.name || !file.size) return 'Invalid file';
    
    // Check file extension if specific extensions are required
    if (allowedExtensions.length > 0) {
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (!allowedExtensions.includes(fileExtension)) {
        return `Only ${allowedExtensions.join(', ')} files are allowed`;
      }
    }
    
    // Check file size
    if (file.size > maxSize) {
      return `File size must be less than ${maxSize / (1024 * 1024)}MB`;
    }
    
    return null;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Button
        variant="outlined"
        component="label"
        startIcon={<Description />} // Changed icon
        disabled={showProgress}
      >
        {label}
        <input
          type="file"
          accept={accept}
          hidden
          multiple={multiple}
          onChange={handleFileChange}
        />
      </Button>

      {showProgress && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <CircularProgress 
            variant={uploadProgress === 0 ? 'indeterminate' : 'determinate'} 
            value={uploadProgress} 
            size={24} 
          />
          <Typography variant="caption">
            {uploadProgress > 0 ? `${uploadProgress}%` : 'Uploading...'}
          </Typography>
        </Box>
      )}
    </Box>
  );
};

export default ImageUploader;